/*
 * @Author: Lijiahui
 * @Date: 2020-10-16 11:11:52
 * @LastEditors: Yuan Wei Lin
 * @LastEditTime: 2024-03-13 11:32:22
 */

import axios from "axios";
export const requestInterceptors = (config) => {
  // if (config.method.toLowerCase() === "post") {
  //   config.data = config.data;
  // } else {
  //   config.params = config.params;
  // }
  return config;
};
axios.defaults.baseURL = process.env.VUE_APP_API_BASEURL;
axios.interceptors.request.use(requestInterceptors);
axios.interceptors.response.use(
  (res) => {
    return Promise.resolve(res.data);
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
